import { z } from 'zod'

interface FileUploadOptions {
  readonly mimes: readonly string[]
  readonly maxKb: number
}

const MIME_BY_EXTENSION: ReadonlyMap<string, string> = new Map([
  ['gif', 'image/gif'],
  ['jpeg', 'image/jpeg'],
  ['jpg', 'image/jpeg'],
  ['png', 'image/png'],
  ['webp', 'image/webp']
])

const extensionOf = (name: string): string => name.slice(name.lastIndexOf('.') + 1).toLowerCase()

// Laravel `mimes` sniffs content; file selection checks the byte signature (sniffImageMimeType), this sync contract the name or type.
export const fileUpload = ({ mimes, maxKb }: FileUploadOptions): z.ZodType<File> => {
  const extensions = new Set(mimes)
  const types = new Set(mimes.flatMap((extension) => MIME_BY_EXTENSION.get(extension) ?? []))

  return z
    .instanceof(File)
    .refine(
      (file) =>
        (file.name.includes('.') && extensions.has(extensionOf(file.name))) || types.has(file.type),
      { params: { file_rule: 'mimes', types: mimes.join(', ') } }
    )
    .refine((file) => file.size <= maxKb * 1024, {
      params: { file_rule: 'max', max: maxKb / 1024 }
    })
}
